module.exports = __webpack_public_path__ + "static/media/send-gray.95bdf82c.svg";